<!--护士-->
<template>
  <div class="">
    <realTime ref="callpolice" />
  </div>
</template>

<script>
import realTime from '../../component/realTime/realTime.vue';

export default {
  components: { realTime },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
  beforeDestroy() {},
};
</script>
<style lang="less"></style>
